export * from './lib/shared-data-access-users.module';

import * as UsersFeature from './lib/+state/users.reducer';

import * as UsersSelectors from './lib/+state/users.selectors';
export { usersLoadedResolver } from './lib/services/user.resolver';

export * from './lib/+state/users.models';

export { UsersService } from './lib/services/users.service';

export { UsersFeature, UsersSelectors };
